import { Button, Paper, Toolbar, Typography } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { TableList } from '../../../common/components/TableList';
import { UserRestriction } from '../../../common/components/UserRestiction';
import { getProject } from '../../../common/services/project';
import { buildLink } from '../../../common/services/tools';
import { IRootState } from '../../../typings';
import { fetchMatchVideos } from '../../matchVideos/actions';
import { MatchVideoRow } from '../../matchVideos/List/MatchVideoRow.component';

interface IOwnProps {
  matchId: string;
}

const mapDispatchToProps = { fetchMatchVideos };

const mapStateToProps = (state: IRootState) => ({
  matchVideos: state.matchVideos.list,
  fetching: state.matchVideos.fetching,
  pagination: state.matchVideos.pagination,
  total: state.matchVideos.totalItems,
});

type IProps = IOwnProps & typeof mapDispatchToProps & ReturnType<typeof mapStateToProps> & InjectedIntlProps;

const TABLE_HEADERS = [
  { labelKey: 'field_thumbnail' },
  { labelKey: 'field_match' },
  { labelKey: 'field_title' },
  { labelKey: 'field_duration' },
  { labelKey: 'field_provider' },
  { labelKey: 'field_publishedAt' },
];

// "Vidéos" tab of the match page: the match videos, with a shortcut to add one for this match.
class VideosComponent extends React.Component<IProps> {
  public componentDidMount() {
    this.fetchData();
  }

  public componentDidUpdate(prevProps: IProps) {
    if (prevProps.matchId !== this.props.matchId) {
      this.fetchData();
    }
  }

  public render() {
    const {
      matchId,
      matchVideos,
      fetching,
      pagination,
      total,
      intl: { messages: m },
    } = this.props;
    const addHref = `#${getProject().url}/match-videos/add?match=${encodeURIComponent(buildLink('Match', matchId))}`;

    return (
      <Paper elevation={2}>
        <Toolbar>
          <Typography variant="h6">{m.app_matchVideos}</Typography>
          <div style={{ flex: 1 }} />
          <UserRestriction>
            <Button variant="contained" color="primary" href={addHref}>
              <AddIcon style={{ marginRight: 8 }} />
              {m.button_add}
            </Button>
          </UserRestriction>
        </Toolbar>
        <TableList
          tableData={matchVideos}
          tableHeaders={TABLE_HEADERS}
          Row={MatchVideoRow}
          loading={fetching}
          pagination={pagination}
          total={total}
          onPaginate={this.fetchData}
        />
      </Paper>
    );
  }

  private fetchData = (query: object = {}) => {
    this.props.fetchMatchVideos({ 'match.id': this.props.matchId, ...query });
  };
}

export const Videos = compose<IProps, IOwnProps>(connect(mapStateToProps, mapDispatchToProps), injectIntl)(VideosComponent);
